import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { TranformedRemixerProjectResponse } from 'services/api/remixer/transformers';
import { NavLink } from 'components';
import { StudioIcon } from 'assets/icons';
import { locations } from 'services/routes/locations';
import BaseIconComponent from 'components/SongActionButtons/components/BaseIconComponent';
import DeleteButton from '../DeleteButton/DeleteButton';
import {
  ActionsWrapper,
  CreationDate,
  ProjectItemContainer,
  StyledDivider,
} from './styled';
import { dateFormatter } from './helpers';

type PropTypes = {
  project: TranformedRemixerProjectResponse;
};

const StudioProjectItem = ({ project }: PropTypes) => {
  const { t } = useTranslation();
  const { id, title, createdAt } = project;

  return (
    <ProjectItemContainer>
      <Box>
        <Typography>{title}</Typography>
        <CreationDate>{dateFormatter(createdAt)}</CreationDate>
      </Box>
      <ActionsWrapper>
        <NavLink to={locations.studio.project.pathname(id)}>
          <BaseIconComponent
            title={t('distribution:tooltip:edit')}
            icon={<StudioIcon />}
          />
        </NavLink>
        <StyledDivider orientation="vertical" />
        <DeleteButton projectId={id} />
      </ActionsWrapper>
    </ProjectItemContainer>
  );
};

export default StudioProjectItem;
